import styled from 'styled-components';

// Components
import { Layout } from 'top-component-library';

const { Content } = Layout;

// Styled Components
export const FullScreenLayout = styled(Layout)`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow: hidden;
  background-color: var(--color-neutral__page-background);

  &.add-card {
    main {
      height: 100vh;
      overflow-y: auto;
    }
  }
`;

export const PaddedContent = styled(Content)`
  display: flex;
  flex-basis: auto;
  flex-shrink: 0;
  position: relative;
`;
